module.exports = __webpack_public_path__ + "img/code2-text.ddbb1f4c.png";